import {
  EnjoymentIcon,
  FamilyIcon,
  HealthIcon,
  HopeIcon,
  MoneyIcon,
  MoodIcon,
  PostpartumIcon,
  RelationshipsIcon,
  SocialSupportIcon,
  WorkIcon,
} from "~/common/components/icons/functionalDomains/v2";
import {
  DIRECT_INQUIRY,
  INDIRECT_INQUIRY,
} from "../constants/patientIntakePreview";
import {
  DirectInquiryType,
  IndirectInquiryType,
} from "./types/patientIntakePreview";
import {
  FUNCTIONAL_DOMAIN_KEY,
  FunctionalDomainKeys,
} from "./types/patientIntakePreviewTypes";

const DOMAIN_TO_ICON_MAP = {
  [FUNCTIONAL_DOMAIN_KEY.enjoyment]: EnjoymentIcon,
  [FUNCTIONAL_DOMAIN_KEY.family]: FamilyIcon,
  [FUNCTIONAL_DOMAIN_KEY.health]: HealthIcon,
  [FUNCTIONAL_DOMAIN_KEY.hope]: HopeIcon,
  [FUNCTIONAL_DOMAIN_KEY.money]: MoneyIcon,
  [FUNCTIONAL_DOMAIN_KEY.mood]: MoodIcon,
  [FUNCTIONAL_DOMAIN_KEY.post_partum]: PostpartumIcon,
  [FUNCTIONAL_DOMAIN_KEY.relationships]: RelationshipsIcon,
  [FUNCTIONAL_DOMAIN_KEY.social_support]: SocialSupportIcon,
  [FUNCTIONAL_DOMAIN_KEY.work]: WorkIcon,
};

export const INDIRECT_TO_SWATCH_MAP = {
  [INDIRECT_INQUIRY.positive]: {
    primary: "#268E34",
    secondary: "#96E9A8",
  },
  [INDIRECT_INQUIRY.partially_positive]: {
    primary: "#268E34",
    secondary: "#96E9A8",
  },
  [INDIRECT_INQUIRY.mixed]: {
    primary: "#D78100",
    secondary: "#FFDDA1",
  },
  [INDIRECT_INQUIRY.neutral]: {
    primary: "#596574",
    secondary: "#EAEBF0",
  },
  [INDIRECT_INQUIRY.partially_negative]: {
    primary: "#C8322B",
    secondary: "#FFCECC",
  },
  [INDIRECT_INQUIRY.negative]: {
    primary: "#C8322B",
    secondary: "#FFCECC",
  },
  [INDIRECT_INQUIRY.na]: {
    primary: "#323539",
    secondary: "#4C5560",
  },
};

export const DIRECT_TO_INDIRECT_TO_SWATCH_MAP = {
  [DIRECT_INQUIRY.positive]: {
    [INDIRECT_INQUIRY.positive]: INDIRECT_TO_SWATCH_MAP.positive,
    [INDIRECT_INQUIRY.partially_positive]: INDIRECT_TO_SWATCH_MAP.positive,
    [INDIRECT_INQUIRY.mixed]: INDIRECT_TO_SWATCH_MAP.positive,
    [INDIRECT_INQUIRY.neutral]: INDIRECT_TO_SWATCH_MAP.positive,
    [INDIRECT_INQUIRY.partially_negative]: INDIRECT_TO_SWATCH_MAP.mixed,
    [INDIRECT_INQUIRY.negative]: INDIRECT_TO_SWATCH_MAP.mixed,
    [INDIRECT_INQUIRY.na]: INDIRECT_TO_SWATCH_MAP.positive,
  },
  [DIRECT_INQUIRY.mixed]: {
    [INDIRECT_INQUIRY.positive]: INDIRECT_TO_SWATCH_MAP.positive,
    [INDIRECT_INQUIRY.partially_positive]: INDIRECT_TO_SWATCH_MAP.positive,
    [INDIRECT_INQUIRY.mixed]: INDIRECT_TO_SWATCH_MAP.mixed,
    [INDIRECT_INQUIRY.neutral]: INDIRECT_TO_SWATCH_MAP.mixed,
    [INDIRECT_INQUIRY.partially_negative]: INDIRECT_TO_SWATCH_MAP.negative,
    [INDIRECT_INQUIRY.negative]: INDIRECT_TO_SWATCH_MAP.negative,
    [INDIRECT_INQUIRY.na]: INDIRECT_TO_SWATCH_MAP.mixed,
  },
  [DIRECT_INQUIRY.negative]: {
    [INDIRECT_INQUIRY.positive]: INDIRECT_TO_SWATCH_MAP.mixed,
    [INDIRECT_INQUIRY.partially_positive]: INDIRECT_TO_SWATCH_MAP.mixed,
    [INDIRECT_INQUIRY.mixed]: INDIRECT_TO_SWATCH_MAP.negative,
    [INDIRECT_INQUIRY.neutral]: INDIRECT_TO_SWATCH_MAP.negative,
    [INDIRECT_INQUIRY.partially_negative]: INDIRECT_TO_SWATCH_MAP.negative,
    [INDIRECT_INQUIRY.negative]: INDIRECT_TO_SWATCH_MAP.negative,
    [INDIRECT_INQUIRY.na]: INDIRECT_TO_SWATCH_MAP.negative,
  },
  [DIRECT_INQUIRY.na]: {
    [INDIRECT_INQUIRY.positive]: INDIRECT_TO_SWATCH_MAP.positive,
    [INDIRECT_INQUIRY.partially_positive]: INDIRECT_TO_SWATCH_MAP.positive,
    [INDIRECT_INQUIRY.mixed]: INDIRECT_TO_SWATCH_MAP.mixed,
    [INDIRECT_INQUIRY.neutral]: INDIRECT_TO_SWATCH_MAP.mixed,
    [INDIRECT_INQUIRY.partially_negative]: INDIRECT_TO_SWATCH_MAP.negative,
    [INDIRECT_INQUIRY.negative]: INDIRECT_TO_SWATCH_MAP.negative,
    [INDIRECT_INQUIRY.na]: INDIRECT_TO_SWATCH_MAP.neutral,
  },
};

export const getPreviewFunctionalDomainsIcon = (
  directInquiry: DirectInquiryType,
  indirectInquiry: IndirectInquiryType,
  section: FunctionalDomainKeys,
) => {
  const Icon = DOMAIN_TO_ICON_MAP[section];

  return (
    <Icon
      width={30}
      height={30}
      fill={
        DIRECT_TO_INDIRECT_TO_SWATCH_MAP[directInquiry][indirectInquiry].primary
      }
      stroke={
        DIRECT_TO_INDIRECT_TO_SWATCH_MAP[directInquiry][indirectInquiry].primary
      }
      style={{
        backgroundColor:
          DIRECT_TO_INDIRECT_TO_SWATCH_MAP[directInquiry][indirectInquiry]
            .secondary,
        borderRadius: 4,
        flexShrink: 0,
      }}
    />
  );
};
